import React, { Component } from 'react';
import { ColorButton } from '../../../../../neoverv';
import Autoload from '../../../../../neoverv/Autoload';
import { connect } from 'react-redux';
import { Group, Radio, RadioGroup, Stack } from '@mantine/core';
import Logo from '../../../../../assets/images/module/general/Logo.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import paypal from '../../../../../assets/images/module/general/paypal.svg';
import mastercard from '../../../../../assets/images/module/general/mastercard.svg';
import visa from '../../../../../assets/images/module/general/visa.svg';
import { setCookie } from '../../../../../neoverv/helpers/Utils';
import {
  setSelectedSubscriptionForPaymentConfirmation
} from '../../../../../redux/action/General/generalActions';
import { showNotification } from '@mantine/notifications';
import DirectDebitConfirmationMessageModal from '../../../../../neoverv/components/Module/General/CustomModal/DirectDebitConfirmationMessageModal';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, loader } = Autoload.MainHelper;
export class PaymentTemplate extends Component {
  state = {
    paymentMethodExist: false,
    type: null,
    selectedPaymentMethod: null,
    paymentMethodError: false,
    showLoader: false,
    openDirectDebitConfirmationMessageModal: false
  };

  componentDidMount() {
    this.getPaymentDetails();

    let url = new URL(window.location.href);
    console.log('type: ',url.searchParams.get("type"));
    this.setState({
      type: url.searchParams.get("type")
    })
  }

  getPaymentDetails = () => {
    console.log('this.props.profile', this.props.profile.accountId, this.props.profile);
    const userAccountID = this.props.profile.accountId;
    // console.log(userAccountID, 'userAccountID from redux - payment details page');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + userAccountID + '/paymentMandate',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_account_payment_details',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handle_account_payment_details(response) {
    console.log('handle_account_payment_details response', response);
    if (response.status == true && response.statuscode == 200) {
      this.setState({
        paymentMethodExist: response.result && response.result.paymentMethod ? true : false
      });
    }
    
    window.Intercom("update", {
      "Payment method": response?.result?.paymentMethod ? (response?.result?.isManuallyCreated && response?.result?.paymentMethod === 'directdebit') ? 'directdebit-hh' : response?.result?.paymentMethod : 'none',
      "Payment mandate id": response?.result?.paymentMandateid ? response?.result?.paymentMandateid : 'none'
    });
}

authorizePayment=()=>{
    this.setState({paymentMethodError: false, showLoader: true})
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.account_api_baseurl + userAccountID + '/authorizePayment',
        'PUT',
        {
            accountId: userAccountID,
            paymentMethod: this.state.selectedPaymentMethod
        },
        null,
        false,
        true,
        false,
        this,
        'handle_account_authorize_payment',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
}
handle_account_authorize_payment(response){
    console.log('handle_account_authorize_payment: ', response);
    if(response.status){
        setCookie('PaymentAuthorizeInProgress', '1');
        setCookie('paymentReAuthorizeInProgress', '0');
        setCookie('SubscriptionSelected', this.props.subscribtionSelected);
        this.props.setSelectedSubscriptionForPaymentConfirmation(this.props.subscribtionSelected);
        setCookie('PaymentAuthorizeRoute', this.props.route);
        //window.location.href = response.result;
        setTimeout(() => {
          window.open(response.result, '_self');
        }, 1000);
        this.props.toggle();
    }
    this.setState({showLoader: false});
}

reAuthorizePayment = () => {
  this.setState({paymentMethodError: false, showLoader: true})
  let accountId = this.props.profile.accountId;
  let payload = { accountId: accountId, paymentMethod: this.state.selectedPaymentMethod };

  Autoload.HttpRequestAxios.HttpRequest(
    Autoload.Setting.api_base_url + `user-api/Accounts/${accountId}/reauthorizePayment`,
    'PUT',
    payload,
    null,
    false,
    true,
    false,
    this,
    'handleChangePaymentOptionResponse',
    null,
    false,
    '',
    { Authorization: Autoload.Utils.getAuthToken() }
  );
};
handleChangePaymentOptionResponse = (response) => {
  if (response.result) {
    setCookie('paymentReAuthorizeInProgress', '1');
    setCookie('PaymentAuthorizeInProgress', '0');
    setCookie('SubscriptionSelected', this.props.subscribtionSelected);
    this.props.setSelectedSubscriptionForPaymentConfirmation(this.props.subscribtionSelected);
    setCookie('PaymentAuthorizeRoute', this.props.route);
    window.open(response.result, '_self');
    this.props.toggle();
  }
  this.setState({showLoader: false});
};

  handleNext=(userBankDetails=null)=>{
    const {type} = this.props;
    const {selectedPaymentMethod} = this.state;
    if(selectedPaymentMethod){
      if(selectedPaymentMethod === 'directdebit' && userBankDetails){
        //TODO: create mandate
        this.createMandate(userBankDetails);
      }else{
        if(type === 'authorize'){
          this.authorizePayment();
        }else{
          this.reAuthorizePayment();
        }
      }
    }else{
      this.setState({paymentMethodError: true});
    }
    // if(type === 'authorize'){
    //   (selectedPaymentMethod ? this.authorizePayment() : this.setState({paymentMethodError: true}))
    // }else{
    //   (selectedPaymentMethod ? this.reAuthorizePayment() : this.setState({paymentMethodError: true}))
    // }
  }

  createMandate=(userBankDetails)=>{
    const {accountData} = this.props;
    let payload = {
      accountId: accountData.accountId,
      paymentMethod: this.state.selectedPaymentMethod,
      consumerName: window.location.href.includes('app.') ? userBankDetails?.consumerName : 'Tom',//userBankDetails?.consumerName,
      consumerAccount: window.location.href.includes('app.') ? userBankDetails?.consumerAccount : 'NL55INGB0000000000',//userBankDetails?.consumerAccount,
      consumerBic: window.location.href.includes('app.') ? userBankDetails?.consumerBic : 'INGBNL2A'
    }
    loader(true);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'accounts/paymentMandate',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handleCreateMandate',
      {payload},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleCreateMandate(response){
    const {type, toggle, setSelectedSubscriptionForPaymentConfirmation, openPaymentStatusModal} = this.props;
    if(response.status && response.statuscode === 200){
      // setCookie('PaymentAuthorizeInProgress', type === 'authorize' ? '1' : '0');
      // setCookie('paymentReAuthorizeInProgress', type === 'authorize' ? '0' : '1');
      // setCookie('SubscriptionSelected', this.props.subscribtionSelected);
      // setSelectedSubscriptionForPaymentConfirmation(this.props.subscribtionSelected);
      // setCookie('PaymentAuthorizeRoute', this.props.route);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
      setSelectedSubscriptionForPaymentConfirmation(this.props.subscribtionSelected);
      openPaymentStatusModal();
      toggle();
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>
      });
      window.Intercom('trackEvent', 'post-payment-mandate-failed', response.other.payload);
      openPaymentStatusModal();
      toggle();
    }
    loader(false);
  }

  render() {
    const {type, toggle, accountData, hasTested, subscribtionSelected} = this.props;
    const {selectedPaymentMethod, paymentMethodError, showLoader, openDirectDebitConfirmationMessageModal} = this.state;
    console.log('selectedPaymentMethod: ', selectedPaymentMethod);
    console.log('this.props.subscribtionSelected: ', this.props.subscribtionSelected);
    console.log('this.props.subscribtionSelectedName: ', this.props.subscribtionSelectedName);
    console.log('accountData: ', accountData);

    return (
        <Stack className='payment-template' style={{marginTop: '0px'}} gap={0}>
            {subscribtionSelected &&
            hasTested ?
            <Group>
              <span className='payment-template-text'>Um ein Abonnement freizuschalten, müssen Sie ein Zahlungsmittel hinterlegen.</span>
            </Group>
            :
            <Group>
              <span className='payment-template-text'>Um ein Abonnement freizuschalten, müssen Sie ein Zahlungsmittel hinterlegen. Die erste Abbuchung findet erst nach Abschluss des Testzeitraums statt.</span>
            </Group>
            }

            {/* {this.props.subscribtionSelected &&
            (this.props.subscribtionSelectedName === 'Premium' ? accountData.isPremiumPlanTested === false &&
            <Group>
              <span className='payment-template-text'>Um das kostenlose Probeabo zu starten, müssen Sie ein Zahlungsmittel hinterlegen. Es wird im ersten Monat keine Zahlung abgebucht. Das Probeabo ändert sich nach Ablauf des Probezeitraums in ein kostenpflichtiges Abo um. Sie können das Probeabo jederzeit kündigen.</span>
            </Group>
            :
            this.props.subscribtionSelectedName === 'Professional' && accountData.isProfessionalPlanTested === false &&
            <Group>
              <span className='payment-template-text'>Um das kostenlose Probeabo zu starten, müssen Sie ein Zahlungsmittel hinterlegen. Es wird im ersten Monat keine Zahlung abgebucht. Das Probeabo ändert sich nach Ablauf des Probezeitraums in ein kostenpflichtiges Abo um. Sie können das Probeabo jederzeit kündigen.</span>
            </Group>)
            } */}
            <Group>
              <span className='payment-template-text'>Bitte wählen Sie das gewünschte Zahlungsmittel:<span style={{color: '#dc3545', fontSize: '12px', fontWeight: '500'}}> *</span></span>
            </Group>
            <Stack style={{background: '#F7F7FA', padding: 10, borderRadius: '4px', marginBottom: '20px'}}>
              {paymentMethodError &&
              <Group>
                <span style={{color: '#dc3545', fontSize: '12px', fontWeight: '500'}}>Bitte wählen Sie eine Zahlungsmethode aus.</span>
              </Group>}
              <Radio.Group
                orientation="vertical"
                value={selectedPaymentMethod}
                onChange={(value)=> this.setState({selectedPaymentMethod: value, paymentMethodError: false})}
                required
              >
                <Radio style={{marginBottom: '7px'}} value="creditcard" label={<span className='payment-template-options'>{"Kreditkarte"} <img src={"https://www.mollie.com/external/icons/payment-methods/creditcard.svg"} style={{marginLeft: '10px'}}/></span>} /> 
                <Radio style={{marginBottom: '7px'}} value="paypal" label={<span className='payment-template-options'>{"Paypal"} <img src={"https://www.mollie.com/external/icons/payment-methods/paypal.svg"} style={{marginLeft: '10px'}}/></span>}/>
                {/* <Radio value="giropay" label={<span className='payment-template-options'>{"Giropay"}<img src={"https://www.mollie.com/external/icons/payment-methods/giropay.svg"} style={{marginLeft: '10px'}}/></span>}/> */}

                <Radio style={{marginBottom: '7px'}} value="directdebit" //sofort
                label={<span className='payment-template-options'>{"Lastschrifteinzug"}
                <img src={"https://www.mollie.com/external/icons/payment-methods/directdebit.svg"} style={{marginLeft: '10px'}}/></span>}/>
              </Radio.Group>
            </Stack>
            {(selectedPaymentMethod === 'creditcard' || selectedPaymentMethod === 'paypal') &&
            <Group style={{marginBottom: '10px'}}>
              <span className='payment-template-options' style={{textAlign: 'left'}}>Zur Autorisierung des Zahlungsmittels leiten wir Sie im nächsten Schritt an unseren Zahlungsanbieter mollie weiter. Es wird noch keine Zahlung getätigt.</span>
            </Group>}
            {/* <Group>
              <span className='payment-template-options' style={{textAlign: 'left', fontSize: '10px'}}>1: Aus technischen Gründen wird zur Autorisierung ein Betrag von 0,10 EUR abgebucht. Dieser wird Ihnen mit der ersten Rechnung erstattet.</span>
            </Group> */}
            <Group style={{width: '100%', justifyContent: 'space-between', marginTop: '30px'}}>
                <div>
                    <ColorButton 
                        text={'Abbrechen'}
                        className='gray-btn'
                        onClick={toggle}
                    />
                </div>
                <div>
                    <ColorButton 
                        text={'Weiter'}
                        className='purple-btn'
                        onClick={()=> selectedPaymentMethod === 'directdebit' ? this.setState({openDirectDebitConfirmationMessageModal: true}) : this.handleNext()}
                        showLoader={showLoader}
                    />
                </div>
            </Group>
            {openDirectDebitConfirmationMessageModal &&
            <DirectDebitConfirmationMessageModal
            open={openDirectDebitConfirmationMessageModal}
            accountData={accountData}
            toggle={()=> this.setState({openDirectDebitConfirmationMessageModal: false})}
            next={(userBankDetails)=> this.setState({openDirectDebitConfirmationMessageModal: false},()=> this.handleNext(userBankDetails))}
            />}
        </Stack>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.generalReducer.profile,
    AccountApi: state.generalReducer.account_api_id,
    accountData: state.generalReducer.accountData,
    hasTested: state.generalReducer.hasTested
  };
};

const actions={
  setSelectedSubscriptionForPaymentConfirmation
}

export default connect(mapStateToProps, actions)(PaymentTemplate);
